<template>
  <div class="approveCard">
    <div class="cardTitle">
      <h3>审批流程</h3>
    </div>
    <div class="listCard">
      <div
        class="listBox"
        v-for="(item, index) in myDataObj.flowChart"
        v-if="index < myDataObj.flowChart.length - 1"
      >
        <div class="listBoxLeft">
          <div class="iconBox">
            <img
              v-if="item.pass === 1"
              src="@/assets/img/approvalSuccess.png"
              alt=""
            />
            <img
              v-else-if="item.pass === -1"
              src="@/assets/img/approvalErr.png"
              alt=""
            />
            <i v-else></i>
          </div>
          <span
            :class="item.pass === 1 ? 'successBorder' : 'errBorder'"
            v-if="index !== myDataObj.flowChart.length - 2"
          ></span>
        </div>
        <div
          class="listBoxRight"
          :style="{
            background:
              item.pass === -1 || item.pass === -2
                ? 'rgba(255,246,246,1)'
                : 'rgba(247,248,249,1)'
          }"
        >
          <h4 v-if="item.nodeType == 1">{{ item.promoterName }}发起审批</h4>
          <h4 v-else-if="item.pass == -2">
            {{ item.workFlowApproveTask[0].approverName }}撤回审批
          </h4>
          <h4 v-else>{{ item.nodeName }}</h4>
          <span class="promoterTime" v-if="item.nodeType == 1"
            >发起时间：{{ item.promoterTime }}</span
          >
          <span class="promoterTime" v-else-if="item.pass == -2"
            >撤回时间：{{ item.workFlowApproveTask[0].approveTime }}</span
          >
          <div class="tastCard" v-for="task in item.workFlowApproveTask">
            <div class="receiverNameCard">
              <span
                >{{ task.receiverName }}
                {{
                  task.itemPassMethod == 1
                    ? '审批通过'
                    : task.itemPassMethod == 2
                    ? '审批未通过'
                    : task.itemPassMethod == 6
                    ? '撤回审批'
                    : ''
                }}</span
              >
              <img
                v-if="task.itemPassMethod == 1"
                src="@/assets/img/approvalSuccess.png"
                alt=""
              />
              <img
                v-if="task.itemPassMethod == 2 || task.itemPassMethod == 6"
                src="@/assets/img/approvalErr.png"
                alt=""
              />
            </div>
            <div
              class="idea"
              v-if="task.itemPassMethod == 1 || task.itemPassMethod == 2"
            >
              {{ task.idea }}
            </div>
            <span
              class="promoterTime"
              v-if="task.itemPassMethod == 1 || task.itemPassMethod == 2"
              >审批时间：{{ task.approveTime }}</span
            >
            <span
              class="promoterTime"
              v-if="task.itemPassMethod == 1 || task.itemPassMethod == 2"
              >审批时长：{{ task.diff | timeFilter }}</span
            >
            <span class="promoterTime" v-if="task.itemPassMethod == 6"
              >撤回时间：{{ task.approveTime }}</span
            >
          </div>
          <div v-if="item.defUserNames" class="defUserNames">
            抄送人员：{{ item.ccUserNames }}
          </div>
        </div>
      </div>
      <div v-if="myDataObj.endCcUserNames" class="endCcUserNames">
        流程结束抄送人员：{{ myDataObj.endCcUserNames }}
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/css/components/approvalProgress.less'

export default {
  name: 'approvalProgress',
  props: {
    myDataObj: {}
  },
  filters: {
    timeFilter: ts => {
      var dd = parseInt(ts / 60 / 60 / 24, 10) //计算剩余的天数
      var hh = parseInt((ts / 60 / 60) % 24, 10) //计算剩余的小时数
      var mm = parseInt((ts / 60) % 60, 10) //计算剩余的分钟数
      var ss = parseInt(ts % 60, 10) //计算剩余的秒数
      return dd + '天' + hh + '小时' + mm + '分' + ss + '秒'
    }
  }
}
</script>
